import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Programming Foundations in C & C++",
    description:
      "Basics of C and C++ syntax, Variables data types operators & input/output, Conditional statements loops & logic building, Functions recursion & modular programming, Understanding memory stack & heap concepts",
  },
  {
    title: "Pointers, Memory Management & Dynamic Allocation",
    description:
      "Pointer basics pointer arithmetic, Arrays & pointers relationship, Dynamic memory allocation using malloc calloc new delete, Double pointers & memory efficiency, Understanding segmentation faults & memory leaks",
  },
  {
    title: "Arrays, Strings & Basic Data Handling",
    description:
      "1D & 2D arrays, String manipulation functions, Searching & sorting basics, Time and space complexity calculation, Solving real-world problems using arrays",
  },
  {
    title: "Linked Lists & Advanced Pointer Operations",
    description:
      "Singly doubly & circular linked lists, Insertion deletion reversal & traversal operations, Implementing stacks & queues using linked lists, Memory-efficient linked list handling, Solving coding challenges on linked lists",
  },
  {
    title: "Stacks, Queues & Sliding Window Techniques",
    description:
      "Array-based & linked list-based stack/queue, Applications in expression evaluation, Circular queues & deque, Sliding window algorithm concepts, Solving monotonic stack/queue problems",
  },
  {
    title: "Trees, Binary Trees & Binary Search Trees (BST)",
    description:
      "Tree terminology representation & traversal, Preorder inorder postorder traversals, BST operations: insert search delete, Balanced trees (AVL Red-Black Tree – basics), Solving tree-based problem-solving questions",
  },
  {
    title: "Heaps, Priority Queues & Advanced Data Structures",
    description:
      "Min heap max heap operations, Priority queue implementation, Heapify & heap sort, Introduction to hash maps & hash tables, Collision handling methods",
  },
  {
    title: "Graphs, DFS, BFS & Path Algorithms",
    description:
      "Graph representation: adjacency matrix & list, Breadth-First Search (BFS) & Depth-First Search (DFS), Shortest path algorithms: Dijkstra Floyd-Warshall, Topological sort & cycle detection, Solving competitive graph problems",
  },
  {
    title: "Algorithms, Complexity & Problem-Solving Techniques",
    description:
      "Time & space complexity (Big-O notation), Divide & conquer: merge sort quicksort, Greedy algorithms: activity selection Huffman coding, Dynamic programming: memoization & tabulation, Mastering pattern-based problem solving",
  },
  {
    title: "Capstone DSA Project & Competitive Coding Prep",
    description:
      "Build a complete DSA project in C/C++, 100+ problem-solving practice workflow, GitHub portfolio creation, Resume building for software engineering roles, Interview prep for DSA rounds (Amazon, Google, Microsoft, startups)",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
